import WarningAlertComponent from '../WarningAlert.component';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChildAlertProps } from '../BaseAlert.component';

const NotificationRemoveAlertComponent = ({
  handleConfirm,
}: ChildAlertProps) => {
  const { t } = useTranslation();

  return (
    <WarningAlertComponent onClose={handleConfirm}>
      {t('Notification will be removed')}.
      <br />
      {t('Continue')}?
    </WarningAlertComponent>
  );
};

export default NotificationRemoveAlertComponent;
